import React, { useState } from 'react'
import styled from 'styled-components';
import BrandLogo from "../../Images/ms-logo.png";


const Root = styled.div`
  background-color: #000000;
  @media (max-width: 767px) {
    padding-top: 30px;
  }
`;
const Container = styled.div`
width: 1680px;
margin: 0 auto;
padding: 50px 0;
`;
const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;
const Div = styled.div`
  display: flex;
  justify-content: right;
  flex-direction: column;
  width: 33.33%;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const InfoWrapper = styled.div`
  width: 30%;
  min-width: 30%;
  padding-right: 40px;
  @media (max-width: 888px) {
    width: 100%;
  }
  @media (max-width: 767px) {
    width: 100%;
  }
`;
const Image = styled.img`
  width: 110px;
  margin-bottom: 10px;
`;

const Text = styled.div`
font-style: normal;
font-weight: 400;
font-size: 18px;
line-height: 22px;
color: #FFFFFF;
  text-align: left;
  margin-bottom: 20px;
  word-break: break-word;
  width:70%;
  @media (max-width: 767px) {
    line-height: 1.5;
  }
`;
const A = styled.a`
  margin-right: 12px;
  font-size: 30px;
  color: rgb(104, 115, 125);
  :hover {
    color: #06615a;
  }
`;

const IconWrapper = styled.div`
  display: none;
  font-size: 18px;
  @media (max-width: 888px) {
    margin-bottom: 20px;
  }
  @media (min-width: 767px) {
    display: flex;
  }
`;

const Link = styled.div`
font-style: normal;
font-weight: 500;
font-size: 20px;
line-height: 45px;
color: #B3B3B3;
  /* :hover {
    text-decoration: ${(props) =>
    props.textDecoration ? props.textDecoration : "underline"};
    color: ${(props) => (props.color ? props.color : "#06615a")};
    font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "500")};
  } */
  @media (max-width: 767px) {
    margin-top: 0;
    margin-bottom: 20px;
  }
`;

const Heading = styled.div`
font-style: normal;
font-weight: 700;
font-size: 24px;
line-height: 35px;
color: #F5FBF2;
padding-bottom:25px;

  /* color: #03363d;
  font-weight: bold;
  letter-spacing: 1.5px;
  font-size: 15px;
  margin-bottom: 10px;
  text-transform: uppercase; */
  @media (max-width: 767px) {
    margin-bottom: 25px;
    cursor: pointer;
  }
`;

const FooterLink = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: flex-start;
  @media (max-width: 888px) {
    flex-direction: column;
  }
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;
const BottomText = styled.div`
  text-align: center;
  padding-bottom: 10px;
  color: #464646;
  font-size: 14px;
`;

const Line = styled.div`
  background-color: #f1f7f5;
  width: 100%;
  height: 2px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const LinkDesktopView = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: flex;
    flex-direction: column;
  }
`;

const LinkMobileView = styled.div`
  display: none;
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
  }
`;

const EventIconWrapper = styled.div`
  display: none;
  @media (max-width: 767px) {
    display: flex;
  }
`;

const HeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LinkWrapper = styled.div`
  display: flex;
  width: 70%;
  min-width: 70%;
  justify-content: space-between;
  @media (max-width: 888px) {
    width: 100%;
  }
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

const IconWrappperMobileView = styled.div`
  font-size: 18px;
  display: none;
  @media (max-width: 767px) {
    display: flex;
  }
`;

const FooterBottomLink = styled.span`
  cursor: pointer;
  :hover {
    color: #03363d;
    text-decoration: underline;
  }
`;

export const Footer = () => {

    const [showcompanyList, setShowCompanyList] = useState(false);
    const [showServiceList, setShowServiceList] = useState(false);
    const [showcontactList, setShowContactList] = useState(false);


  return (
    <Root>
    <Container>
      <Wrapper>
        <FooterLink>
          <InfoWrapper>
            <Image src={BrandLogo} />
            <Text>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </Text>
           
          </InfoWrapper>
          <LinkWrapper>
            <Div align="center" width="23.33%">
              <HeadingWrapper
                onClick={() => setShowCompanyList(!showcompanyList)}
              >
                <Heading>About </Heading>
                {!showcompanyList ? (
                  <EventIconWrapper>
                    <i className="fa-solid fa-plus"></i>
                  </EventIconWrapper>
                ) : (
                  <EventIconWrapper>
                    <i className="fa-solid fa-minus"></i>
                  </EventIconWrapper>
                )}
              </HeadingWrapper>
              <LinkDesktopView>
                <Link
                 
                >
               About NFT
                </Link>
                <Link >
                Live Auctions 
                </Link>

                <Link >
                NFT Blog 
                </Link>
                <Link >
                Activity
                </Link>
              </LinkDesktopView>
              {showcompanyList && (
                <LinkMobileView>
                  <Link
                  
                  >
                    About Us
                  </Link>
                  <Link >
                    Contact
                  </Link>
                </LinkMobileView>
              )}
            </Div>
            <Div align="center" width="23.33%">
              <HeadingWrapper>
                <Heading
                  onClick={() => setShowServiceList(!showServiceList)}
                >
                Support
                </Heading>
                {!showServiceList ? (
                  <EventIconWrapper>
                    <i className="fa-solid fa-plus"></i>
                  </EventIconWrapper>
                ) : (
                  <EventIconWrapper>
                    <i className="fa-solid fa-minus"></i>
                  </EventIconWrapper>
                )}
              </HeadingWrapper>
              <LinkDesktopView>
                <Link
                 
                >
                Help & Support
                </Link>
                <Link
                
                >
                  Item Details
                </Link>
                <Link
               
                >
                Author Profile
                </Link>
                <Link
                
                >
                 Collection
                </Link>
               
             
              </LinkDesktopView>
              {showServiceList && (
                <LinkMobileView>
                  <Link
                  
                  >
                    Blockchain Development
                  </Link>
                  <Link
                 
                  >
                    Game Developrment
                  </Link>
                  <Link
                   
                  >
                    Metaverse Developrment
                  </Link>
                  <Link
                   
                  >
                    Mobile App Developrment
                  </Link>
                  <Link
                   
                  >
                    Web Development
                  </Link>
                  <Link
                   
                  >
                    Crypto Currency Development
                  </Link>
                  <Link
                   
                  >
                    Nft MarketPlace Development
                  </Link>
                </LinkMobileView>
              )}
            </Div>
            <Div align="center" width="23.33%">
              <HeadingWrapper
                onClick={() => {
                  setShowContactList(!showcontactList);
                }}
              >
                <Heading> Join the Community  </Heading>
                {!showcontactList ? (
                  <EventIconWrapper>
                    <i className="fa-solid fa-plus"></i>
                  </EventIconWrapper>
                ) : (
                  <EventIconWrapper>
                    <i className="fa-solid fa-minus"></i>
                  </EventIconWrapper>
                )}
              </HeadingWrapper>
              {showcontactList && (
                <LinkMobileView>
                
                  <IconWrappperMobileView>
                    <A
                      href="#"
                      // target="_blank"
                    >
                      <i className="fa-brands fa-facebook"></i>
                    </A>
                    <A
                      href="#"
                      // target="_blank"
                    >
                      <i className="fa-brands fa-twitter"></i>
                    </A>
                    <A
                      href="#"
                      // target="_blank"
                    >
                      <i className="fa-brands fa-instagram"></i>
                    </A>
                    <A
                      href="#"
                      // target="_blank"
                    >
                      <i className="fa-brands fa-linkedIn"></i>
                    </A>
                    <A
                      href="#"
                      // target="_blank"
                    >
                      <i className="fa-brands fa-pinterest"></i>
                    </A>
                  </IconWrappperMobileView>
                </LinkMobileView>
              )}
              <LinkDesktopView>
              <IconWrapper>
              <A
                href="#"
                target="_blank"
              >
                <i className="fa-brands fa-facebook"></i>
              </A>
              <A
                href="#"
                target="_blank"
              >
                <i className="fa-brands fa-instagram"></i>
              </A>
              <A href="#" target="_blank">
                <i className="fa-brands fa-twitter"></i>
              </A>
              <A
                href="#"
                target="_blank"
              >
                <i className="fa-brands fa-linkedin"></i>
              </A>
              <A
                href="#"
                target="_blank"
              >
                <i className="fa-brands fa-pinterest"></i>
              </A>
            </IconWrapper>
                
              </LinkDesktopView>
            </Div>
          </LinkWrapper>
        </FooterLink>
      </Wrapper>
    </Container>
  </Root>
  )
}
